export const colors = {
    primary: {
        dark: '#090719',

        light: '#FFFFFF',
    },
    secondary: {
        error: '#EE0A4A',
    },
};
